import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from 'src/environments/environment';
import { DateTime } from 'luxon';
import { BackendService } from '../../services/backend/backend.service';
import { startWith } from 'rxjs';
import { BackendStorage } from '../../services/backend/backend.models';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-layout-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './layout-footer.component.html',
  styleUrls: ['./layout-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutFooterComponent {
  protected readonly version = environment.version;
  protected readonly today = DateTime.now().toJSDate();
  protected readonly storage$ = this.backendService.getStorage().pipe(
    takeUntilDestroyed(),
    startWith<BackendStorage>({
      used: '0.00 KB',
      available: '0.00 GB',
      percentage: '0.0000%',
    })
  );
  protected readonly vm = Object.freeze({
    storage: toSignal(this.storage$, { requireSync: true }),
  });

  constructor(private readonly backendService: BackendService) {}
}
